import * as React from 'react';
import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { deserializeConnectionState } from 'app/area/case/draft/connected-state';
import { Bowtie } from './bowtie';
import { BowtieDisplayMode } from './external-types';
import { withRouter, WithRouterProps } from 'app/components/enhancers/with-router';
import { useInstanceKey } from 'app/area/favourite/favourite-context';
import { ModalType } from 'app/components/constants';
import { Case } from 'app/area/case';
import { CaseViewModal } from 'app/area/case/components/case-view-modal';

interface BowtieParams {
  id: string;
  modalType?: string;
  bowtieId?: string;
}

export const BowtieScreen: React.FC<React.PropsWithChildren<BowtieParams & WithRouterProps>> = (props) => {

  const caseNumber = safeNumericString(props.params.id);
  const connectedDrafts = deserializeConnectionState(props.router.location.query);
  const instanceKey = useInstanceKey();
  const renderCaseViewModal = props.modalType === ModalType.caseViewModal;
  const CaseWithRouter = withRouter(Case);

  if (caseNumber === '') {
    return null;
  }

  return (
    <div>
      <Bowtie
        caseNumber={caseNumber}
        connectedDrafts={connectedDrafts}
        favouriteId={undefined}
        instanceKey={instanceKey}
        displayMode={BowtieDisplayMode.fullscreen}
      />
      {renderCaseViewModal && (
        <CaseViewModal
          children={<CaseWithRouter />}
          bowtieId={Number(props.params.bowtieId)}
        />
      )}
    </div>
  );
};
